import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialLevageMaterialPageState,
  LevageMaterialItemData,
} from "../core/_model.levage";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedLevageMaterial = {
  data: LevageMaterialItemData | null;
  action: ActionsKey;
};

type LevageMaterialDataType = {
  levageMaterialList: any;
  detail: LevageMaterialItemData | null;
  actioned: ActionedLevageMaterial | null;
  totalItems?: number;
  setDetail: (detail: LevageMaterialItemData | null) => void;
  setLevageMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedLevageMaterial | null) => void;
};

export const useLevageMaterialStore = create<LevageMaterialDataType>((set) => ({
  levageMaterialList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  setDetail: (detail) => set((state) => ({ detail })),
  setLevageMaterialList: (levageData) =>
    set((state) => ({
      levageMaterialList: levageData?.member,
      totalItems: levageData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useLevageMaterialListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialLevageMaterialPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
